import request from '@/plugin/axios'; //所有菜单

export function fetchMenus(params) {
  return request({
    url: 'admin/menu/all',
    method: 'get',
    params: params
  });
} //角色对应的菜单

export function fetchRoleMenus(params) {
  return request({
    url: 'admin/menu/permitted',
    method: 'get',
    params: params
  });
}